import { 
    gql, 
    useMutation, 
    ApolloError,
} from "@apollo/client";
import { 
    UpdateAdminAdminMutationMutation,
    UpdateAdminAdminMutationMutationVariables 
} from "../../../../../schemaTypes";

export const updateAdminAdminMutation = gql`
  mutation UpdateAdminAdminMutation(
    $id: String!
    $input: UpdateAdminAdminInput!
    ) {
    updateAdminAdmin(
        id: $id
        input: $input
      ) {
      errors {
        path
        message
      }
      message
    }
  }
`;

interface Props {
  onMessage?: (message: string) => void;
  children: (
    data: {
      submit: (
        values: UpdateAdminAdminMutationMutationVariables & { profilePictureFile?: File }
      ) => Promise<{
        errors: ({ path: string; message: string } | null)[] | null;
        message?: string;
      }>;
      loading: boolean;
      error?: ApolloError;
    }
  ) => React.ReactElement | null;
}

function fileToBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

export const UpdateAdminAdminController: React.FC<Props> = ({ children, onMessage }) => {
  const [updateAdminAdmin, { loading, error }] = useMutation<
    UpdateAdminAdminMutationMutation,
    UpdateAdminAdminMutationMutationVariables
  >(updateAdminAdminMutation);

const submit = async (
  values: UpdateAdminAdminMutationMutationVariables & {
    input: UpdateAdminAdminMutationMutationVariables["input"] & {
      profilePictureFile?: File;
    };
  }
) => {
  const { profilePictureFile, ...inputRest } = values.input;

  let profilePictureUrl = inputRest.profilePictureUrl;

  if (profilePictureFile) {
    profilePictureUrl = await fileToBase64(profilePictureFile);
  }

  const { data } = await updateAdminAdmin({
    variables: {
      id: values.id,
      input: {
        ...inputRest,
        profilePictureUrl,
      },
    },
  });

  const errors = data?.updateAdminAdmin?.errors ?? null;
  const message = data?.updateAdminAdmin?.message ?? undefined;

  if (message && onMessage) {
    onMessage(message);
  }

  return {
    errors,
    message,
  };
};


  return children({ submit, loading, error });
};